'use client'
import { getStore } from '../../store.js';

const setUser = (user) => getStore().setState({ user });
const getUser = () => getStore().getState().user;

export { getUser, setUser };
